import { gql } from '@apollo/client'

export const MUTATION_CREATE_FILE_DRAFT = gql`
  mutation createProjectFileDraft($input: FileCreateInput!) {
    createFileDraft(input: $input) {
      id
      uploadLink
    }
  }
`

export const MUTATION_VALIDATE_FILE = gql`
  mutation validateFile($input: FileValidateInput!) {
    validateFile(input: $input)
  }
`

export const MUTATION_CREATE_FILE_DRAFT_FOR_PROJECT_FILE_VALIDATION_REQUEST = gql`
  mutation createFileDraftForProjectFileValidationRequest($input: FileCreateForProjectFileValidationRequestInput!) {
    createFileDraftForProjectFileValidationRequest(input: $input) {
      id
      uploadLink
    }
  }
`

export const MUTATION_VALIDATE_FILE_FOR_PROJECT_FILE_VALIDATION_REQUEST = gql`
  mutation validateFileForProjectFileValidationRequest($input: FileValidateForProjectFileValidationRequestInput!) {
    validateFileForProjectFileValidationRequest(input: $input)
  }
`
